import './InlineSpinner.scss'

export type InlineSpinnerProps = {
    size?: number;
    className?: string;
};

const InlineSpinner = ({ size = 15, className }: InlineSpinnerProps) => {
    return (
        <span
            className={`inline-spinner-slot ${className ?? ''}`}
            style={{
                height: size,
                minWidth: size,
            }}
        >
      <span
          className="inline-spinner"
          style={{
              width: size,
              height: size,
              borderWidth: Math.max(2, Math.floor(size / 6)),
          }}
      />
    </span>
    );
};

export default InlineSpinner;
